import type { ValuesType } from 'utility-types'

export const ARRIVAL_METHOD = {
  home: 1,
  store: 2,
}

export type AddressArrivalMethod = typeof ARRIVAL_METHOD
export type AddressArrivalMethodKeys = keyof AddressArrivalMethod
export type AddressArrivalMethodValues = ValuesType<AddressArrivalMethod>
